import classes from "./Vienna_slide.module.css";
import MediaS from "../MediaS";
import AddMedia from "../AddMedia";
import ModalView from "../Modal/ModalView";
import EditOrgModal from "../Modal/EditOrg_modal";
import {useCallback, useEffect, useRef, useState} from "react";
import logo from "../../../store/logo.png";
import axios from "axios";
import {path} from "../../../routes";
import {Button, CircularProgress, Divider, FormControl, InputLabel, MenuItem, Select, Switch, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Checkbox, Box, Typography, IconButton} from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';

const Diplomat_slide = (props) =>{
    const [user, setUser] = useState(props.cred);
    const publicBaseUrl = String(path || '')
        .replace(/\/api\/?$/i, '')
        .replace(/\/$/, '');

    const toPublicUploadUrl = (p) => {
        if (!p) return '';
        if (String(p).startsWith('http')) return String(p);
        // Extract filename from path (remove all prefixes)
        const cleaned = String(p)
            .replace(/\\/g, '/')
            .replace(/^\/+/, '')
            .replace(/^admin\/uploads\//i, '')
            .replace(/^uploads\//i, '')
            .replace(/^admin\//i, '');
        // Always use /uploads/ prefix in the final URL
        return `${publicBaseUrl}/uploads/${cleaned}`;
    };
    const isVideoUrl = (u) => /\.(mp4|webm|mov|m4v|avi|mkv)(\?.*)?$/i.test(String(u || ''));
    const isPdfUrl = (u) => /\.pdf(\?.*)?$/i.test(String(u || ''));
    const isHttpUrl = (u) => /^https?:\/\//i.test(String(u || '').trim());

    const apiCandidates = (endpoint) => {
        const base = String(path || '').replace(/\/$/, '');
        const ep = String(endpoint || '').replace(/^\/+/, '');
        // Try both: s /api i bez (path může být https://x.cz/api nebo https://x.cz)
        const c1 = `${base}/${ep}`;
        const c2 = base.endsWith('/api') ? base.replace(/\/api$/, '') + '/' + ep : `${base}/api/${ep}`;
        return Array.from(new Set([c1, c2]));
    };

    const postWithFallback = async (endpoint, body) => {
        let lastErr;
        for (const url of apiCandidates(endpoint)) {
            try {
                return await axios.post(url, body);
            } catch (e) {
                lastErr = e;
                if (e?.response?.status && e.response.status !== 404) throw e;
            }
        }
        throw lastErr;
    };

    const putWithFallback = async (endpoint, body) => {
        let lastErr;
        for (const url of apiCandidates(endpoint)) {
            try {
                return await axios.put(url, body);
            } catch (e) {
                lastErr = e;
                if (e?.response?.status && e.response.status !== 404) throw e;
            }
        }
        throw lastErr;
    };

    const deleteWithFallback = async (endpoint, config = {}) => {
        let lastErr;
        for (const url of apiCandidates(endpoint)) {
            try {
                return await axios.delete(url, config);
            } catch (e) {
                lastErr = e;
                if (e?.response?.status && e.response.status !== 404) throw e;
            }
        }
        throw lastErr;
    };

    const temp = {
        id: 0,
        Header: "Namespace",
        Body: {
            file: "",
            imgURL: logo,
            elevators: [
                {
                    name: "E1_",
                    checked: false
                },
                {
                    name: "E2_",
                    checked: true
                },
                {
                    name: "E3_",
                    checked: false
                }
            ]
        }
    }
    const [idCount, setIdCount] = useState(1);
    const [groupid, setGroupid] = useState(0);
    const [currentID, setCurrentID] = useState(null);
    const [cards, setCards] = useState([])
    const [cardsNew, setCardsNew] = useState([])
    const [modalLoaded, setModalLoaded] = useState(false);
    const [modalVariant, setModalVariant] = useState(null);
    const [images, setImages] = useState([]);
    const [fileContent, setFileContent] = useState('');
    const [radioDown, setradioDown] = useState(0);
    const [radioUp, setradioUp] = useState(0);
    const [slideGroups, setSlideGroups] = useState([]);
    const [organization, setOrganization] = useState(null);
    const [editOrgModalOpen, setEditOrgModalOpen] = useState(false);
    const [createGroupModalOpen, setCreateGroupModalOpen] = useState(false);
    const [newGroupName, setNewGroupName] = useState('');
    const [devices, setDevices] = useState([]);
    const [selectedDevices, setSelectedDevices] = useState([]);
    const [editGroupModalOpen, setEditGroupModalOpen] = useState(false);
    const [editGroupName, setEditGroupName] = useState('');
    const [editGroupSelectedDevices, setEditGroupSelectedDevices] = useState([]);
    const [deviceGroupAssignments, setDeviceGroupAssignments] = useState({});
    const [editGroupSlideInterval, setEditGroupSlideInterval] = useState('15'); // interval (s) pro celou groupu
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewCard, setPreviewCard] = useState(null);
    
    // --- Kiosk demo (for #slideshow View demo) ---
    const [demoOpen, setDemoOpen] = useState(false);
    const [selectedKioskId, setSelectedKioskId] = useState('');
    const [demoRatioFromDevice, setDemoRatioFromDevice] = useState(null);
    const [demoDeviceSettings, setDemoDeviceSettings] = useState(null); // full device settings when demo opens (null = loading)
    const selectedKioskIdRef = useRef(selectedKioskId);

    const RATIO_OPTIONS = ['9:16', '16:9', '4:3'];
    selectedKioskIdRef.current = selectedKioskId;

    // Když se otevře Edit group, předvyplnit slide interval z prvního zařízení ve skupině (pokud má uložené nastavení)
    useEffect(() => {
        if (!editGroupModalOpen || !groupid) return;
        const groupIdNum = Number(groupid);
        const deviceInGroup = (devices || []).find(d => Number(d.roomGroup ?? d.room_group) === groupIdNum);
        if (!deviceInGroup) {
            setEditGroupSlideInterval('15');
            return;
        }
        const orgId = props.cred?.cOrganization_id;
        const base = String(path || '').replace(/\/$/, '');
        const url = orgId
            ? `${base}/getDeviceSettings/${deviceInGroup.id}?orgID=${encodeURIComponent(orgId)}`
            : `${base}/getDeviceSettings/${deviceInGroup.id}`;
        let cancelled = false;
        (async () => {
            try {
                const resp = await axios.get(url);
                if (cancelled) return;
                const sec = resp.data?.settings?.slideIntervalSec;
                if (typeof sec === 'number' && !Number.isNaN(sec)) {
                    const clamped = Math.max(3, Math.min(300, Math.floor(sec)));
                    setEditGroupSlideInterval(String(clamped));
                } else {
                    setEditGroupSlideInterval('15');
                }
            } catch {
                if (!cancelled) setEditGroupSlideInterval('15');
            }
        })();
        return () => { cancelled = true; };
    }, [editGroupModalOpen, groupid, devices, props.cred?.cOrganization_id]);

    const [modalBodyUpdate,setmodalBodyUpdate]=useState({
        name:"",
        device:null,
        date:"2020-11-11 00:00:00",
        dateFrom:"2020-11-11 00:00:00",
        dateTo:"2020-11-11 00:00:00",
        room:"A-D"
    })
    const [modalBody, setModalBody] = useState({
        file: "",
        text: "testik",
        v1: false,
        v2: true,
        v3: true
    });
    const fetchSlideGroups = async (gr) => {
        try {
            // Try both /getSlideGroup and /api/getSlideGroup to support different deployments
            const base = String(path || '').replace(/\/$/, '');
            const orgID = props.cred.cOrganization_id;
            const urls = Array.from(new Set([
                `${base}/getSlideGroup?orgID=${orgID}`,
                `${base}/api/getSlideGroup?orgID=${orgID}`,
            ]));
            let response;
            for (const url of urls) {
                try {
                    response = await axios.get(url);
                    break;
                } catch (e) {
                    if (e?.response?.status && e.response.status !== 404) throw e;
                }
            }
            if (!response) throw new Error('getSlideGroup not found (404)');
            //console.log(response.data);
            // Filter out profile groups (groupId 1 and 2 are device types, not slideshow groups)
            // Also filter out groups without a valid name
            const validGroups = (response.data || []).filter(group => {
                // Exclude device type groups (1 = Display, 2 = Kiosk)
                if (group.groupId === 1 || group.groupId === 2) return false;
                // Exclude groups without a name
                if (!group.groupName || !group.groupName.trim()) return false;
                // Exclude groups that look like profiles (case-insensitive check)
                const nameLower = String(group.groupName).toLowerCase();
                if (nameLower.includes('profile') || nameLower.includes('profil')) return false;
                return true;
            });
            setSlideGroups(validGroups)
            // Debug: potřeba mapovat skupiny pro kiosk slideshow podle názvu/ID
            // (kopíruj výstup do chatu, ať nastavíme správné groupIDs v kiosk UI)
            console.log('[Diplomat_slide] Loaded slide groups:', validGroups.map((g) => ({
                groupId: g.groupId,
                groupName: g.groupName
            })));
        } catch (error) {
            console.error('Error deleting row:', error);
        }
    }
    const fetchOrganization = async () => {
        try {
            const response = await axios.get(`${path}/getOrganization/${props.cred.cOrganization_id}`);
            if (response.data && response.data.length > 0) {
                setOrganization(response.data[0]);
            }
        } catch (error) {
            console.error('Error fetching organization:', error);
        }
    }
    const fetchDevices = async () => {
        try {
            // Kiosks (device_group=2) + tablets/displays (device_group=1) so groups can be assigned to both
            const orgId = props.cred.cOrganization_id;
            const [kiosksRes, displaysRes] = await Promise.all([
                axios.get(`${path}/getDeviceV2?orgID=${orgId}`).catch(() => ({ data: [] })),
                axios.get(`${path}/getDisplaysbyOrg/${orgId}`).catch(() => ({ data: [] }))
            ]);
            const kiosks = Array.isArray(kiosksRes.data) ? kiosksRes.data : [];
            const displays = Array.isArray(displaysRes.data) ? displaysRes.data : [];
            const merged = [...displays, ...kiosks];
            setDevices(merged);
            fetchDeviceGroupAssignments(merged);
        } catch (error) {
            console.error('Error fetching devices:', error);
        }
    }
    const fetchDeviceGroupAssignments = async (deviceList = devices) => {
        const orgId = props.cred?.cOrganization_id;
        if (!Array.isArray(deviceList) || deviceList.length === 0) {
            setDeviceGroupAssignments({});
            return;
        }
        const entries = await Promise.all(deviceList.map(async (d) => {
            const fallback = [];
            const rg = Number(d.roomGroup ?? d.room_group);
            if (Number.isFinite(rg) && rg > 0) fallback.push(Math.floor(rg));
            try {
                const base = String(path || '').replace(/\/$/, '');
                const url = orgId
                    ? `${base}/getDeviceSettings/${d.id}?orgID=${encodeURIComponent(orgId)}`
                    : `${base}/getDeviceSettings/${d.id}`;
                const resp = await axios.get(url);
                const settings = resp.data?.settings || {};
                const extra = Array.isArray(settings.slideshowGroupIds)
                    ? settings.slideshowGroupIds
                        .map((x) => Number(x))
                        .filter((n) => Number.isFinite(n) && n > 0)
                        .map((n) => Math.floor(n))
                    : [];
                return [String(d.id), Array.from(new Set([...fallback, ...extra]))];
            } catch (_) {
                return [String(d.id), fallback];
            }
        }));
        setDeviceGroupAssignments(Object.fromEntries(entries));
    };
    const fetchDataCards = async (gr) => {
        try {
            // Dashboard zobrazuje všechny karty (včetně skrytých) pro správu
            // onlyVisible=1 se používá jen pro slideshow/kiosky
            const orgID = props.cred.cOrganization_id;
            const url = `${path}/getCardsV3?orgID=${orgID}&group=${gr}`;
            console.log('[fetchDataCards] 🔍 Request:', { orgID, group: gr, url });
            const response = await axios.get(url);
            console.log('[fetchDataCards] 📥 Response:', { 
                count: response.data?.length,
                orgID: orgID,
                group: gr,
                cards: response.data?.map(c => ({ 
                    id: c.id?.slice(0, 8), 
                    description: c.description,
                    path: c.path?.slice(0, 30),
                    isVisible: c.isVisible
                }))
            });
            console.log('[fetchDataCards] Raw response (first 3):', response.data?.slice(0, 3).map(c => ({ 
                id: c.id?.slice(0, 8), 
                description: c.description,
                path: c.path,
                isVisible: c.isVisible, 
                isVisibleRaw: c.isVisible,
                type: typeof c.isVisible,
                isVisibleValue: c.isVisible === true || c.isVisible === 1 || String(c.isVisible) === '1'
            })));
            setObje(response.data)
        } catch (error) {
            console.error('Error fetching cards:', error);
            const status = error?.response?.status;
            const data = error?.response?.data;
            if (status === 409 && data?.error === 'Organization not migrated') {
                alert(`${data.error}\n\n${data.hint || 'Run npm run migrate:legacy-to-org'}`);
            } else {
                setObje([]);
            }
        }
    }
    const fetchDataRadio = async (gr) => {
        try {
            const response = await axios.get(`${path}/getCardsV3Radio?groupRadio=${gr}`);
            console.log("RS",response.data[0].vienna_show);
            // Optionally, update your UI to reflect the deletion
           // setObje(response.data)
            if (gr == 5){
                response.data[0].vienna_show == 0? setradioDown(false):setradioDown(true)
            }
            if (gr == 6){
                response.data[0].vienna_show == 0? setradioUp(false):setradioUp(true)
            }
        } catch (error) {
            console.error('Error fetching radio data:', error);
        }
    }
    const updateRadio = async (kiosk) => {
        let tmp
        if (kiosk == 1){
            radioDown == true?tmp=0:tmp=1
        }
        if (kiosk == 2){
            radioUp == true?tmp=0:tmp=1
        }
        const rs = await axios.post(`${path}/updateReset/17`)
    }

    const setObje =  (x) =>{
        let fld=[]
        for(let i = 0;i<x.length;i++){
            const id = x[i].id
            try {
                // Parsování isVisible: SQL Server vrací BIT jako 0/1
                // ISNULL(c.isVisible, 1) znamená: pokud NULL, použij 1, jinak použij hodnotu
                let isVisibleValue = x[i].isVisible;
                
                // Debug: zobrazit hodnotu před parsováním
                if (i < 3) {
                    console.log(`[setObje] Card ${i}: id=${x[i].id?.slice(0, 8)}, isVisible raw=${isVisibleValue}, type=${typeof isVisibleValue}`);
                }
                
                // Parsování: SQL Server BIT může být 0, 1, true, false, nebo null
                // Explicitně zkontrolovat false/0 jako skryté
                let isVisible;
                if (isVisibleValue === null || isVisibleValue === undefined) {
                    // NULL nebo undefined = defaultně viditelná
                    isVisible = true;
                } else if (isVisibleValue === false || isVisibleValue === 0 || String(isVisibleValue) === '0') {
                    // Explicitně false nebo 0 = skrytá
                    isVisible = false;
                } else if (isVisibleValue === true || isVisibleValue === 1 || String(isVisibleValue) === '1') {
                    // Explicitně true nebo 1 = viditelná
                    isVisible = true;
                } else {
                    // Jinak použít truthy check
                    isVisible = Boolean(isVisibleValue);
                }
                
                let temp = {
                    id: id,
                    Header: x[i].description,
                    CreatedBy: x[i].username,
                    isVisible: isVisible,
                    Body: {
                        file: x[i].path,
                        imgURL: toPublicUploadUrl(x[i].path)
                    }
                }
                fld.push(temp)
            } catch (error) {
                console.error('Fetching elevators Error:', error.message);
            }
        }
        console.log('[setObje] 📋 Parsed cards (all):', fld.map(c => ({ 
            id: c.id?.slice(0, 8), 
            Header: c.Header, 
            path: c.Body?.file?.slice(0, 40),
            isVisible: c.isVisible 
        })));
        console.log('[setObje] ✅ Setting cards state with', fld.length, 'cards');
        setCards([...fld])
    }

    const setCardVisibility = async (cardId, visible) => {
        // NEaktualizovat lokální state před voláním backendu - počkat na úspěšnou odpověď
        try {
            const orgId = props.cred?.cOrganization_id;
            const body = { isVisible: visible ? 1 : 0, orgID: orgId };
            const ep = `setCardVisibility/${cardId}${orgId ? '?orgID=' + encodeURIComponent(orgId) : ''}`;
            console.log('[setCardVisibility] 🔄 Frontend request:', { cardId: cardId?.slice(0, 8), visible, orgId, endpoint: ep, body });
            try {
                const response = await putWithFallback(ep, body);
                console.log('[setCardVisibility] ✅ Backend response:', response?.data);
                // Backend úspěšně uložil - znovu načíst karty ze serveru (s onlyVisible=1)
                if (groupid) {
                    console.log('[setCardVisibility] 🔄 Refetching cards after visibility change...');
                    await fetchDataCards(groupid);
                } else {
                    // Pokud nemáme groupid, alespoň aktualizovat lokální state podle odpovědi z backendu
                    if (response?.data) {
                        setCards((prev) => prev.map((c) => 
                            c.id === cardId 
                                ? { ...c, isVisible: Boolean(response.data.isVisible) } 
                                : c
                        ));
                    }
                }
            } catch (putErr) {
                if (putErr?.response?.status === 404) {
                    const response = await postWithFallback(ep, body);
                    // Backend úspěšně uložil - znovu načíst karty ze serveru (s onlyVisible=1)
                    if (groupid) {
                        await fetchDataCards(groupid);
                    } else {
                        // Pokud nemáme groupid, alespoň aktualizovat lokální state podle odpovědi z backendu
                        if (response?.data) {
                            setCards((prev) => prev.map((c) => 
                                c.id === cardId 
                                    ? { ...c, isVisible: Boolean(response.data.isVisible) } 
                                    : c
                            ));
                        }
                    }
                } else {
                    throw putErr;
                }
            }
        } catch (e) {
            // Při chybě znovu načíst karty, aby se obnovil správný stav ze serveru
            if (groupid) await fetchDataCards(groupid);
            const status = e?.response?.status;
            const data = e?.response?.data;
            if (status === 409 && data?.missingColumn) {
                alert(
                    `Cannot change visibility because database column is missing: ${data.missingColumn}\n\n` +
                    `${data.hint || 'Run the migration SQL on the production database.'}`
                );
            } else if (status === 404) {
                alert('Změna viditelnosti se neuložila (404). Zkontrolujte, že server je aktualizovaný a migrace 2026-02-05 byla spuštěna.');
            } else {
                alert('Failed to change visibility.');
            }
        }
    };
    const delete_hanler = (id) => {
        setCurrentID(id)
        setModalVariant(0)
        setModalLoaded(true)
    }
    const preview_handler = (id) => {
        const card = cards.find(c => c.id === id);
        if (card) {
            setPreviewCard(card);
            setPreviewOpen(true);
        }
    }
    const add_hanler = (id) => {
        setModalVariant(1)
        setModalBody(null)
        setModalLoaded(true)
    }
    const modal_close_handler = (id) => {
        setModalVariant(null)
        setModalLoaded(false)
        setModalBody(null)
        if (groupid) fetchDataCards(groupid)
    }
    const add_toCards_handler = (card) => {
        setCards([...cards, card])
        setIdCount(idCount + 1)
    }
    const delete_fnc = async (id) => {

        for (let i = 0;i<cards.length;i++){
            //let tempY = cards
            if ( id === cards[i].id){
                const pathFile = cards[i].Body.file;
                //console.warn(cards[i])
                cards.splice(i, 1)
                try {
                    const orgId = props.cred?.cOrganization_id;
                    const url = orgId ? `${path}/deleteRow/${id}?orgID=${encodeURIComponent(orgId)}` : `${path}/deleteRow/${id}`;
                    await axios.delete(url)
                    console.log('Row deleted successfully');
                    // Optionally, update your UI to reflect the deletion
                } catch (error) {
                    console.error('Error deleting row:', error);
                }

            }
            // id === cards[i].id? cards.splice(i, 1):console.log("upsii")
        }
        console.log("deleting id no. ",id)

    }
    useEffect(()=>{
        fetchSlideGroups()
        fetchOrganization()
        fetchDevices()
    },[])

    // When devices load, pick first kiosk by default
    useEffect(() => {
        if (selectedKioskId) return;
        const kiosks = (devices || []).filter(d => Number(d.device_group) === 2);
        if (kiosks.length > 0) setSelectedKioskId(String(kiosks[0].id));
    }, [devices, selectedKioskId]);

    // When group changes: if current kiosk is not assigned to this group, switch to one that is (so demo loads the right device settings)
    useEffect(() => {
        if (!groupid || !(devices || []).length) return;
        const kiosks = (devices || []).filter(d => Number(d.device_group) === 2);
        const groupIdNum = Number(groupid);
        const current = kiosks.find(d => String(d.id) === String(selectedKioskId));
        const currentInGroup = current && Number(current.roomGroup ?? current.room_group) === groupIdNum;
        if (currentInGroup) return;
        const forGroup = kiosks.find(d => Number(d.roomGroup ?? d.room_group) === groupIdNum);
        if (forGroup) setSelectedKioskId(String(forGroup.id));
    }, [groupid, devices, selectedKioskId]);

    const copyToClipboard = async (text) => {
        try {
            const value = String(text);
            if (navigator.clipboard?.writeText) {
                await navigator.clipboard.writeText(value);
                alert('Link copied to clipboard.');
                return true;
            }
            const ta = document.createElement('textarea');
            ta.value = value;
            ta.setAttribute('readonly', '');
            ta.style.position = 'fixed';
            ta.style.opacity = '0';
            document.body.appendChild(ta);
            ta.select();
            const ok = document.execCommand('copy');
            document.body.removeChild(ta);
            if (ok) alert('Link copied to clipboard.');
            return ok;
        } catch (e) {
            console.error('Copy failed:', e);
            return false;
        }
    };

    const parseRatio = (ratio) => {
        const m = String(ratio || '').match(/^(\d+)\s*:\s*(\d+)$/);
        const w = m ? Number(m[1]) : 9;
        const h = m ? Number(m[2]) : 16;
        return { w: w || 9, h: h || 16 };
    };

    const getDisplayBaseUrl = () => {
        if (typeof window === 'undefined') return 'https://kiosk.csgcontrols.cz';
        return `${window.location.origin}/`;
    };

    const buildKioskUrl = ({ kioskId, orgId, groupId, demoRatio: ratio, settings = {} }) => {
        if (typeof window === 'undefined') return '';
        if (!kioskId || !orgId) return '';
        const base = getDisplayBaseUrl();
        const params = new URLSearchParams();
        params.set('room', String(kioskId));
        params.set('orgID', String(orgId));
        params.set('id', '100');
        if (groupId) params.set('group', String(groupId));
        if (ratio) params.set('demoRatio', ratio);
        if (settings.slideIntervalSec != null) params.set('slideInterval', String(settings.slideIntervalSec));
        if (settings.objectFit === 'cover' || settings.objectFit === 'contain') params.set('fit', settings.objectFit);
        if (settings.showLogo === false) params.set('showLogo', '0');
        if (settings.showClock === false) params.set('showClock', '0');
        if (settings.showDate === false) params.set('showDate', '0');
        if (settings.showTemp === false) params.set('showTemp', '0');
        return `${base}?${params.toString()}`;
    };

    // When demo opens or selected kiosk changes: load that device's settings (never use stale settings for another device)
    useEffect(() => {
        if (!demoOpen) {
            setDemoRatioFromDevice(null);
            setDemoDeviceSettings(null);
            return;
        }
        if (!selectedKioskId) return;
        setDemoDeviceSettings(null);
        setDemoRatioFromDevice(null);
        const requestedId = String(selectedKioskId);
        let cancelled = false;
        (async () => {
            try {
                const resp = await axios.get(`${path}/getDeviceSettings/${requestedId}`);
                const s = resp.data?.settings || {};
                if (cancelled) return;
                if (String(selectedKioskIdRef.current) !== requestedId) return;
                setDemoDeviceSettings(s);
                const r = s.demoRatio;
                if (typeof r === 'string' && RATIO_OPTIONS.includes(r)) setDemoRatioFromDevice(r);
                else setDemoRatioFromDevice(null);
            } catch (_) {
                if (!cancelled && String(selectedKioskIdRef.current) === requestedId) {
                    setDemoDeviceSettings({});
                    setDemoRatioFromDevice(null);
                }
            }
        })();
        return () => { cancelled = true; };
    }, [demoOpen, selectedKioskId]);

    const effectiveDemoRatio = (demoRatioFromDevice && RATIO_OPTIONS.includes(demoRatioFromDevice))
        ? demoRatioFromDevice
        : '9:16';

    const getDemoUrl = () => {
        const settings = demoDeviceSettings || {};
        const ratio = (settings.demoRatio && RATIO_OPTIONS.includes(settings.demoRatio))
            ? settings.demoRatio
            : (effectiveDemoRatio || undefined);
        return buildKioskUrl({
            kioskId: selectedKioskId,
            orgId: props.cred.cOrganization_id,
            groupId: groupid || null,
            demoRatio: ratio,
            settings,
        });
    };

    const kioskDemoUrl = demoDeviceSettings !== null ? getDemoUrl() : '';
    const demoFullscreenRef = useRef(null);
    const [isDemoFullscreen, setIsDemoFullscreen] = useState(false);

    // Debug: do konzole rozlišení / poměr pro demo
    useEffect(() => {
        if (!demoOpen) return;
        const vw = typeof window !== 'undefined' ? window.innerWidth : 0;
        const vh = typeof window !== 'undefined' ? window.innerHeight : 0;
        const expectedWidth = effectiveDemoRatio === '9:16'
            ? (vh * 0.95 * 9 / 16)
            : effectiveDemoRatio === '16:9'
                ? Math.min(vw * 0.95, vh * 0.95 * 16 / 9)
                : Math.min(vw * 0.95, vh * 0.95 * 4 / 3);
        const expectedHeight = vh * 0.95;
        console.log('[Kiosk Demo – slideshow]', {
            demoRatio: effectiveDemoRatio || '(nevybráno)',
            fromDevice: demoRatioFromDevice || '(device/state)',
            demoUrl: kioskDemoUrl || '(chybí)',
            viewport: `${vw}×${vh}`,
            očekávanéRozlišeníKontejneru: `${Math.round(expectedWidth)}×${Math.round(expectedHeight)}`,
            aspectRatio: effectiveDemoRatio === '9:16' ? '9:16 (portrét)' : effectiveDemoRatio === '16:9' ? '16:9 (landscape)' : effectiveDemoRatio === '4:3' ? '4:3' : '?',
        });
    }, [demoOpen, effectiveDemoRatio, demoRatioFromDevice, kioskDemoUrl]);

    const syncDemoFullscreenState = useCallback(() => {
        if (typeof document === 'undefined') return;
        const current = demoFullscreenRef.current;
        setIsDemoFullscreen(Boolean(current && document.fullscreenElement === current));
    }, []);

    const toggleDemoFullscreen = useCallback(async () => {
        const el = demoFullscreenRef.current;
        if (!el || typeof document === 'undefined') return;
        try {
            if (document.fullscreenElement) {
                await document.exitFullscreen?.();
            } else {
                await el.requestFullscreen?.();
            }
        } catch (e) {
            console.error('Fullscreen toggle failed:', e);
        }
    }, []);

    const closeDemo = useCallback(async () => {
        try {
            if (typeof document !== 'undefined' && document.fullscreenElement) {
                await document.exitFullscreen?.();
            }
        } catch (e) {
            // ignore
        } finally {
            setDemoOpen(false);
        }
    }, []);

    // Když je demo otevřené, zobrazit v adresním řádku plnou URL kiosku (ne #slideshow)
    useEffect(() => {
        if (typeof window === 'undefined') return;
        if (demoOpen && kioskDemoUrl) {
            const prevUrl = window.location.href;
            window.history.replaceState(null, '', kioskDemoUrl);
            return () => {
                window.history.replaceState(null, '', prevUrl);
            };
        }
    }, [demoOpen, kioskDemoUrl]);

    useEffect(() => {
        if (typeof document === 'undefined') return;
        const onFs = () => syncDemoFullscreenState();
        document.addEventListener('fullscreenchange', onFs);
        syncDemoFullscreenState();
        return () => document.removeEventListener('fullscreenchange', onFs);
    }, [syncDemoFullscreenState]);
    
    const handleCreateGroup = async () => {
        if (!newGroupName.trim()) {
            alert('Please enter a group name');
            return;
        }
        
        try {
            const response = await postWithFallback('createSlideGroup', {
                groupName: newGroupName,
                orgID: props.cred.cOrganization_id,
                deviceIds: selectedDevices
            });
            
            // Refresh groups list and devices (so roomGroup is up to date for Edit group)
            await fetchSlideGroups();
            await fetchDevices();
            
            // Reset form
            setNewGroupName('');
            setSelectedDevices([]);
            setCreateGroupModalOpen(false);
            
            // Select the newly created group
            if (response.data && response.data.groupId) {
                setGroupid(response.data.groupId);
                fetchDataCards(response.data.groupId);
            }
            
            alert('Group created successfully');
        } catch (error) {
            console.error('Error creating group:', error);
            if (error?.response?.status === 404) {
                alert('Create group endpoint not available. Please contact administrator to deploy the latest server version.');
            } else {
                alert(`Failed to create group: ${error?.message || 'Unknown error'}`);
            }
        }
    }
    
    const handleDeviceToggle = (deviceId) => {
        setSelectedDevices(prev => 
            prev.includes(deviceId) 
                ? prev.filter(id => id !== deviceId)
                : [...prev, deviceId]
        );
    };

    const openEditGroupModal = () => {
        const g = slideGroups.find(sg => Number(sg.groupId) === Number(groupid));
        if (!g) return;
        setEditGroupName(g.groupName || '');
        const groupIdNum = Number(groupid);
        const selected = (devices || [])
            .filter(d => (deviceGroupAssignments[String(d.id)] || []).includes(groupIdNum))
            .map(d => d.id);
        setEditGroupSelectedDevices(selected);
        setEditGroupModalOpen(true);
    };

    const isDeviceSelectedInEdit = (deviceId) =>
        editGroupSelectedDevices.some(id => String(id) === String(deviceId));

    const handleEditGroupDeviceToggle = (deviceId) => {
        setEditGroupSelectedDevices(prev => {
            const has = prev.some(id => String(id) === String(deviceId));
            if (has) return prev.filter(id => String(id) !== String(deviceId));
            return [...prev, deviceId];
        });
    };

    const handleSaveEditGroup = async () => {
        if (!groupid || !editGroupName.trim()) {
            alert('Please enter a group name.');
            return;
        }
        const intervalNum = Number(editGroupSlideInterval || '15');
        const safeInterval = Math.max(3, Math.min(300, Number.isFinite(intervalNum) ? intervalNum : 15));
        try {
            await putWithFallback(`updateSlideGroup/${groupid}`, {
                groupName: editGroupName.trim(),
                orgID: props.cred.cOrganization_id
            });
            // Propagate slide interval and group assignments into device settings
            if (Array.isArray(devices) && devices.length > 0) {
                const orgId = props.cred?.cOrganization_id;
                const groupNum = Number(groupid);
                await Promise.all(devices.map(async (device) => {
                    const deviceId = device.id;
                    try {
                        const base = String(path || '').replace(/\/$/, '');
                        const urlGet = orgId
                            ? `${base}/getDeviceSettings/${deviceId}?orgID=${encodeURIComponent(orgId)}`
                            : `${base}/getDeviceSettings/${deviceId}`;
                        const resp = await axios.get(urlGet);
                        const current = resp.data?.settings || {};
                        const currentIds = Array.isArray(current.slideshowGroupIds)
                            ? current.slideshowGroupIds.map((x) => Number(x)).filter((n) => Number.isFinite(n) && n > 0).map((n) => Math.floor(n))
                            : [];
                        const shouldHave = editGroupSelectedDevices.some((id) => String(id) === String(deviceId));
                        const nextIds = shouldHave
                            ? Array.from(new Set([...currentIds, groupNum]))
                            : currentIds.filter((id) => id !== groupNum);
                        const merged = {
                            ...current,
                            slideIntervalSec: safeInterval,
                            slideshowGroupIds: nextIds
                        };
                        const urlSet = `${base}/setDeviceSettings/${deviceId}`;
                        await axios.put(urlSet, { settings: merged, orgID: orgId });
                        // Keep cDevice.roomGroup in sync as primary group, so kiosk URL fallback is correct.
                        const primaryGroup = nextIds.length > 0 ? nextIds[0] : null;
                        await axios.put(`${base}/updateDisplay/${deviceId}`, {
                            name: device.description || `Device ${deviceId}`,
                            type: device.device_group,
                            organization: orgId,
                            roomGroup: primaryGroup
                        });
                    } catch (e) {
                        console.error('[Diplomat] Failed to update slideIntervalSec for device', deviceId, e);
                    }
                }));
            }
            await fetchSlideGroups();
            await fetchDevices();
            await fetchDeviceGroupAssignments();
            setEditGroupModalOpen(false);
            setEditGroupName('');
            setEditGroupSelectedDevices([]);
            setEditGroupSlideInterval('15');
            alert('Group updated.');
        } catch (error) {
            console.error('Error updating group:', error);
            if (error?.response?.status === 404) {
                alert('Update group endpoint is not available.');
            } else {
                alert(`Error: ${error?.message || 'Failed to save.'}`);
            }
        }
    };

    const getDeviceAssignedGroupsLabel = (device) => {
        const assigned = deviceGroupAssignments[String(device.id)] || [];
        const currentGid = Number(groupid);
        const others = assigned.filter((id) => id !== currentGid);
        if (others.length === 0) return '';
        const names = others.map((id) => (slideGroups || []).find((sg) => Number(sg.groupId) === id)?.groupName || `Group ${id}`);
        return names.join(', ');
    };

    const handleDeleteGroup = async () => {
        if (!groupid) return;
        if (!window.confirm('Delete this group? Devices will be unassigned from it.')) return;
        try {
            const orgId = encodeURIComponent(props.cred.cOrganization_id || '');
            await deleteWithFallback(`deleteSlideGroup/${groupid}?orgID=${orgId}`, {
                data: { orgID: props.cred.cOrganization_id }
            });
            await fetchSlideGroups();
            await fetchDevices();
            setEditGroupModalOpen(false);
            setEditGroupName('');
            setEditGroupSelectedDevices([]);
            setGroupid(0);
            fetchDataCards(0);
            alert('Group deleted.');
        } catch (error) {
            console.error('Error deleting group:', error);
            if (error?.response?.status === 404) {
                alert('Delete group endpoint is not available.');
            } else {
                alert(`Error: ${error?.message || 'Failed to delete.'}`);
            }
        }
    };
    
    const handleEditOrgClose = () => {
        setEditOrgModalOpen(false);
        fetchOrganization(); // Refresh organization data
    }
    const changeTab_handler = (event) =>{
        const temp = event.target.value
//console.log(temp)
        setGroupid(temp)
        fetchDataCards(event.target.value)
        if ( event.target.value == 5 || event.target.value == 6){
            fetchDataRadio(event.target.value)
        }
    }
    const label = { inputProps: { 'aria-label': 'Switch demo' } };
    return <>
        <div className={classes.header}>
            {/* Organization name (read-only) + edit action */}
            <Box sx={{ 
                display: 'flex', 
                flexDirection: { xs: 'column', sm: 'row' },
                alignItems: { xs: 'stretch', sm: 'center' },
                gap: { xs: 1.5, sm: 2 },
                width: '100%',
                mb: { xs: 2, sm: 0 }
            }}>
                <TextField 
                    value={organization?.name || ''} 
                    variant="outlined" 
                    disabled
                    label="Organization"
                    sx={{ 
                        width: { xs: '100%', sm: 'auto' },
                        minWidth: { xs: '100%', sm: 280 },
                        flex: { sm: 1 },
                        '& .MuiOutlinedInput-root': {
                            backgroundColor: 'white',
                            fontSize: '16px',
                            fontWeight: 500
                        }
                    }}
                />
                <Button 
                    variant="outlined" 
                    startIcon={<EditIcon />}
                    onClick={() => setEditOrgModalOpen(true)}
                    sx={{ 
                        width: { xs: '100%', sm: 'auto' },
                        whiteSpace: 'nowrap',
                        minWidth: { xs: '100%', sm: 140 },
                        height: { xs: '48px', sm: '56px' },
                        fontSize: '15px',
                        fontWeight: 500,
                        borderWidth: 2,
                        '&:hover': {
                            borderWidth: 2
                        }
                    }}
                >
                    Edit
                </Button>
            </Box>
            
            {/* Group selection + create new group */}
            <Box sx={{ 
                display: 'flex', 
                flexDirection: { xs: 'column', sm: 'row' },
                gap: { xs: 1.5, sm: 2 }, 
                width: '100%', 
                alignItems: { xs: 'stretch', sm: 'center' }
            }}>
                <FormControl sx={{
                    width: { xs: '100%', sm: '50%' },
                    minWidth: { xs: '100%', sm: 280 }
                }}>
                    <InputLabel id="demo-simple-select-label" sx={{ fontSize: '15px' }}>Group</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={groupid}
                        label="Group"
                        onChange={(x)=>{
                            setGroupid(x.target.value)
                            fetchDataCards(x.target.value)
                        }}
                        sx={{
                            height: { xs: '48px', sm: '56px' },
                            fontSize: '15px',
                            backgroundColor: 'white',
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderWidth: 2
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                borderWidth: 2
                            }
                        }}
                    >
                        <MenuItem value={0}>Select a group</MenuItem>
                        {slideGroups.length > 0 && slideGroups.map((x)=>{
                            return  <MenuItem key={x.groupId} value={x.groupId}>{x.groupName || `Group ${x.groupId}`}</MenuItem>
                        })}
                    </Select>
                </FormControl>
                <Box sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    gap: { xs: 1.5, sm: 1.5 },
                    width: { xs: '100%', sm: 'auto' }
                }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => setCreateGroupModalOpen(true)}
                        sx={{
                            width: { xs: '100%', sm: 'auto' },
                            whiteSpace: 'nowrap',
                            minWidth: { xs: '100%', sm: 180 },
                            height: { xs: '48px', sm: '56px' },
                            fontSize: '15px',
                            fontWeight: 600,
                            boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
                            '&:hover': {
                                boxShadow: '0 6px 16px rgba(25, 118, 210, 0.4)',
                                transform: 'translateY(-1px)'
                            },
                            transition: 'all 0.2s'
                        }}
                    >
                        Create group
                    </Button>

                    <Button
                        variant="outlined"
                        disabled={!groupid}
                        onClick={openEditGroupModal}
                        startIcon={<EditIcon />}
                        sx={{
                            width: { xs: '100%', sm: 'auto' },
                            whiteSpace: 'nowrap',
                            minWidth: { xs: '100%', sm: 140 },
                            height: { xs: '48px', sm: '56px' },
                            fontSize: '15px',
                            fontWeight: 600,
                            borderWidth: 2,
                            '&:hover': { borderWidth: 2 }
                        }}
                    >
                        Edit group
                    </Button>
                </Box>
            </Box>
        </div>

        <div className={classes.cont}>
            {/* Dashboard zobrazuje všechny karty (včetně skrytých) pro správu */}
            {console.log('[Render] 🎨 Rendering', cards.length, 'cards:', cards.map(c => ({ id: c.id?.slice(0, 8), Header: c.Header, path: c.Body?.file?.slice(0, 30) })))}
            {cards.map(x => {
                return <MediaS
                    typ={1}
                    key={x.id}
                    delete={delete_hanler}
                    body={x.Body}
                    text={x.Header}
                    id={x.id}
                    preview={preview_handler}
                    isVisible={x.isVisible}
                    onVisibilityChange={(v) => setCardVisibility(x.id, v)}
                />
        })}
            {groupid !== 0 && <AddMedia click={add_hanler}/>}
        {modalLoaded &&
            <ModalView V={modalVariant} ModalBody={modalBody} close={modal_close_handler} add={add_toCards_handler}
                       addID={idCount} currentID={currentID} delFNC={delete_fnc} cred={user}
                       modalBodyUpdate={modalBodyUpdate} groupID={groupid} updateCount={() => groupid && fetchDataCards(groupid)}/>}

        {/* Kiosk Demo Modal - aspect ratio and settings from device (database) */}
        <Dialog
            open={demoOpen}
            onClose={closeDemo}
            maxWidth={false}
            PaperProps={{
                sx: {
                    borderRadius: '12px',
                    overflow: 'hidden',
                    margin: 'auto',
                    ...(effectiveDemoRatio === '9:16'
                        ? { aspectRatio: '9/16', width: 'calc(95vh * 9 / 16)', height: 'auto', maxHeight: '95vh' }
                        : effectiveDemoRatio === '16:9'
                            ? { aspectRatio: '16/9', width: 'min(95vw, calc(95vh * 16 / 9))', height: 'auto', maxHeight: '95vh' }
                            : { aspectRatio: '4/3', width: 'min(95vw, calc(95vh * 4 / 3))', height: 'auto', maxHeight: '95vh' }
                    )
                }
            }}
        >
            <DialogContent
                ref={demoFullscreenRef}
                sx={{
                    p: 0,
                    position: 'relative',
                    backgroundColor: '#111',
                    height: '100%',
                    overflow: 'hidden'
                }}
            >
                <IconButton
                    aria-label={isDemoFullscreen ? "exit fullscreen" : "fullscreen"}
                    onClick={toggleDemoFullscreen}
                    sx={{
                        position: 'absolute',
                        left: 8,
                        top: 8,
                        color: 'white',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        zIndex: 1,
                        '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' }
                    }}
                >
                    {isDemoFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
                </IconButton>
                <IconButton
                    aria-label="close"
                    onClick={closeDemo}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: 'white',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        zIndex: 1,
                        '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' }
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <Box
                    component="div"
                    sx={{
                        width: '100%',
                        height: '100%',
                        aspectRatio: effectiveDemoRatio === '9:16' ? '9/16' : effectiveDemoRatio === '16:9' ? '16/9' : '4/3',
                        boxSizing: 'border-box',
                        maxWidth: '100%',
                        maxHeight: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    {demoDeviceSettings === null ? (
                        <Box sx={{ color: '#fff', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                            <CircularProgress size={48} sx={{ color: '#fff' }} />
                            <Typography variant="body2">Loading kiosk settings…</Typography>
                        </Box>
                    ) : kioskDemoUrl ? (
                        <iframe
                            title="Kiosk demo"
                            src={kioskDemoUrl}
                            key={kioskDemoUrl}
                            allow="fullscreen"
                            allowFullScreen
                            style={{ width: '100%', height: '100%', border: 0, display: 'block' }}
                        />
                    ) : (
                        <Box sx={{ color: '#fff', p: 2 }}>Could not build demo URL.</Box>
                    )}
                </Box>
            </DialogContent>
        </Dialog>
        
        {/* Organization edit modal */}
        {editOrgModalOpen && organization && (
            <EditOrgModal 
                organization={organization} 
                close={handleEditOrgClose}
            />
        )}
        
        {/* Create new group modal */}
        <Dialog 
            open={createGroupModalOpen} 
            onClose={() => setCreateGroupModalOpen(false)}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: '12px',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)'
                }
            }}
        >
            <DialogTitle sx={{ 
                fontSize: '20px', 
                fontWeight: 600,
                pb: 1,
                borderBottom: '1px solid #e0e0e0'
            }}>
                Create new group
            </DialogTitle>
            <DialogContent sx={{ pt: 3 }}>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Group name"
                    fullWidth
                    variant="outlined"
                    value={newGroupName}
                    onChange={(e) => setNewGroupName(e.target.value)}
                    sx={{ 
                        mb: 3, 
                        mt: 1,
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '8px'
                        }
                    }}
                />
                <Box>
                    <InputLabel sx={{ 
                        mb: 1.5, 
                        fontSize: '15px',
                        fontWeight: 500,
                        color: '#333'
                    }}>
                        Select devices (kiosks and tablets)
                    </InputLabel>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                        On tablets, when there is a meeting, it will override the slideshow.
                    </Typography>
                    <Box sx={{ 
                        maxHeight: 300, 
                        overflow: 'auto', 
                        border: '2px solid #e0e0e0', 
                        borderRadius: '8px', 
                        p: 2,
                        backgroundColor: '#f8f9fa',
                        '&::-webkit-scrollbar': {
                            width: '8px'
                        },
                        '&::-webkit-scrollbar-track': {
                            background: '#f1f1f1',
                            borderRadius: '4px'
                        },
                        '&::-webkit-scrollbar-thumb': {
                            background: '#b0bec5',
                            borderRadius: '4px',
                            '&:hover': {
                                background: '#90a4ae'
                            }
                        }
                    }}>
                        {devices.length === 0 ? (
                            <Box sx={{ 
                                p: 3, 
                                textAlign: 'center', 
                                color: 'text.secondary',
                                fontSize: '14px'
                            }}>
                                No devices available
                            </Box>
                        ) : (
                            devices.map((device) => (
                                <FormControlLabel
                                    key={device.id}
                                    control={
                                        <Checkbox
                                            checked={selectedDevices.includes(device.id)}
                                            onChange={() => handleDeviceToggle(device.id)}
                                            sx={{
                                                '&.Mui-checked': {
                                                    color: '#1976d2'
                                                }
                                            }}
                                        />
                                    }
                                    label={`${device.description || `Device ${device.id}`} (${device.device_group === 1 ? 'Display' : device.device_group === 2 ? 'Kiosk' : 'Unknown'})`}
                                    sx={{
                                        display: 'block',
                                        mb: 1,
                                        '&:hover': {
                                            backgroundColor: 'rgba(25, 118, 210, 0.04)',
                                            borderRadius: '4px',
                                            padding: '4px 8px',
                                            margin: '4px -8px'
                                        }
                                    }}
                                />
                            ))
                        )}
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions sx={{ 
                px: 3, 
                pb: 2.5,
                pt: 2,
                borderTop: '1px solid #e0e0e0',
                gap: 1
            }}>
                <Button 
                    onClick={() => {
                        setCreateGroupModalOpen(false);
                        setNewGroupName('');
                        setSelectedDevices([]);
                    }}
                    sx={{
                        minWidth: 100,
                        fontWeight: 500
                    }}
                >
                    Cancel
                </Button>
                <Button 
                    onClick={handleCreateGroup} 
                    variant="contained"
                    disabled={!newGroupName.trim()}
                    sx={{
                        minWidth: 120,
                        fontWeight: 600,
                        boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
                        '&:hover': {
                            boxShadow: '0 6px 16px rgba(25, 118, 210, 0.4)'
                        },
                        '&:disabled': {
                            backgroundColor: '#e0e0e0',
                            color: '#9e9e9e'
                        }
                    }}
                >
                    Create
                </Button>
            </DialogActions>
        </Dialog>

        {/* Edit group modal – group name + select devices (which kiosks/displays show this group) */}
        <Dialog
            open={editGroupModalOpen}
            onClose={() => { setEditGroupModalOpen(false); setEditGroupName(''); setEditGroupSelectedDevices([]); setEditGroupSlideInterval('15'); }}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: '12px',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)'
                }
            }}
        >
            <DialogTitle sx={{ fontSize: '20px', fontWeight: 600, pb: 1, borderBottom: '1px solid #e0e0e0' }}>
                Edit group
            </DialogTitle>
            <DialogContent sx={{ pt: 3 }}>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Group name"
                    fullWidth
                    variant="outlined"
                    value={editGroupName}
                    onChange={(e) => setEditGroupName(e.target.value)}
                    sx={{ mb: 2, mt: 1, '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                />
                <TextField
                    margin="dense"
                    label="Slide interval (s)"
                    type="number"
                    fullWidth
                    variant="outlined"
                    value={editGroupSlideInterval}
                    onChange={(e) => setEditGroupSlideInterval(e.target.value)}
                    helperText="How long each image is shown on all kiosks/displays in this group (3–300 seconds)."
                    inputProps={{ min: 3, max: 300, step: 1 }}
                    sx={{ mb: 3, '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                />
                <Box>
                    <InputLabel sx={{ mb: 1.5, fontSize: '15px', fontWeight: 500, color: '#333' }}>
                        Devices that show this group (selected devices)
                    </InputLabel>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                        Kiosks and tablets can be assigned. On tablets, when there is a meeting, it will override the slideshow.
                    </Typography>
                    <Box sx={{
                        maxHeight: 300,
                        overflow: 'auto',
                        border: '2px solid #e0e0e0',
                        borderRadius: '8px',
                        p: 2,
                        backgroundColor: '#f8f9fa',
                        '&::-webkit-scrollbar': { width: '8px' },
                        '&::-webkit-scrollbar-track': { background: '#f1f1f1', borderRadius: '4px' },
                        '&::-webkit-scrollbar-thumb': { background: '#b0bec5', borderRadius: '4px', '&:hover': { background: '#90a4ae' } }
                    }}>
                        {(devices || []).length === 0 ? (
                            <Box sx={{ p: 3, textAlign: 'center', color: 'text.secondary', fontSize: '14px' }}>
                                No devices available
                            </Box>
                        ) : (
                            (devices || []).map((device) => {
                                const typeLabel = device.device_group === 1 ? 'Display' : device.device_group === 2 ? 'Kiosk' : '?';
                                const otherGroupsLabel = getDeviceAssignedGroupsLabel(device);
                                const label = `${device.description || `Device ${device.id}`} (${typeLabel})${otherGroupsLabel ? ` — also in: ${otherGroupsLabel}` : ''}`;
                                return (
                                    <FormControlLabel
                                        key={String(device.id)}
                                        control={
                                            <Checkbox
                                                checked={isDeviceSelectedInEdit(device.id)}
                                                onChange={() => handleEditGroupDeviceToggle(device.id)}
                                                sx={{
                                                    '&.Mui-checked': { color: '#1976d2' }
                                                }}
                                            />
                                        }
                                        label={label}
                                        sx={{
                                            display: 'block',
                                            mb: 1,
                                            '&:hover': { backgroundColor: 'rgba(25, 118, 210, 0.04)', borderRadius: '4px', padding: '4px 8px', margin: '4px -8px' }
                                        }}
                                    />
                                );
                            })
                        )}
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2.5, pt: 2, borderTop: '1px solid #e0e0e0', gap: 1, flexWrap: 'wrap' }}>
                <Button
                    onClick={handleDeleteGroup}
                    color="error"
                    variant="outlined"
                    sx={{ mr: 'auto', fontWeight: 500 }}
                >
                    Delete group
                </Button>
                <Button
                    onClick={() => { setEditGroupModalOpen(false); setEditGroupName(''); setEditGroupSelectedDevices([]); }}
                    sx={{ minWidth: 100, fontWeight: 500 }}
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleSaveEditGroup}
                    variant="contained"
                    disabled={!editGroupName.trim()}
                    sx={{
                        minWidth: 120,
                        fontWeight: 600,
                        boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
                        '&:hover': { boxShadow: '0 6px 16px rgba(25, 118, 210, 0.4)' },
                        '&:disabled': { backgroundColor: '#e0e0e0', color: '#9e9e9e' }
                    }}
                >
                    Save
                </Button>
            </DialogActions>
        </Dialog>
        
        {/* Preview Modal */}
        <Dialog
            open={previewOpen}
            onClose={() => setPreviewOpen(false)}
            maxWidth="lg"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: '12px',
                    maxHeight: '95vh',
                    backgroundColor: '#000'
                }
            }}
        >
            <DialogContent sx={{ 
                p: 0, 
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '70vh',
                backgroundColor: '#000'
            }}>
                <IconButton
                    aria-label="close"
                    onClick={() => setPreviewOpen(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: 'white',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        zIndex: 1,
                        '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.7)'
                        }
                    }}
                >
                    <CloseIcon />
                </IconButton>
                {previewCard && (
                    <>
                        <Box sx={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            p: 3,
                            boxSizing: 'border-box'
                        }}>
                            {isVideoUrl(previewCard?.Body?.imgURL) ? (
                                <video
                                    src={previewCard.Body.imgURL}
                                    controls
                                    preload="metadata"
                                    style={{
                                        maxWidth: '100%',
                                        maxHeight: '85vh',
                                        width: 'auto',
                                        height: 'auto',
                                        objectFit: 'contain',
                                        borderRadius: '8px'
                                    }}
                                    onLoadedMetadata={(e) => {
                                        try {
                                            const v = e.currentTarget;
                                            const t = Number.isFinite(v.duration) && v.duration > 1.1 ? 1 : 0;
                                            v.currentTime = t;
                                            v.pause();
                                        } catch (_) {}
                                    }}
                                    onError={(e) => {
                                        console.error('Error loading preview video:', previewCard.Body.imgURL);
                                        e.currentTarget.style.display = 'none';
                                    }}
                                />
                            ) : isPdfUrl(previewCard?.Body?.imgURL) || isHttpUrl(previewCard?.Body?.imgURL) ? (
                                <iframe
                                    title="Preview"
                                    src={previewCard.Body.imgURL}
                                    style={{
                                        width: '100%',
                                        height: '85vh',
                                        border: 0,
                                        borderRadius: '8px',
                                        background: '#fff'
                                    }}
                                    onError={() => {
                                        console.error('Error loading preview iframe:', previewCard.Body.imgURL);
                                    }}
                                />
                            ) : (
                            <img
                                src={previewCard.Body.imgURL}
                                alt={previewCard.Header || 'Preview'}
                                style={{
                                    maxWidth: '100%',
                                    maxHeight: '85vh',
                                    width: 'auto',
                                    height: 'auto',
                                    objectFit: 'contain',
                                    borderRadius: '8px'
                                }}
                                onError={(e) => {
                                    console.error('Error loading preview image:', previewCard.Body.imgURL);
                                        e.currentTarget.style.display = 'none';
                                }}
                            />
                            )}
                        </Box>
                        {previewCard.Header && (
                            <Box sx={{
                                position: 'absolute',
                                bottom: 0,
                                left: 0,
                                right: 0,
                                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                                color: 'white',
                                p: 2,
                                textAlign: 'center'
                            }}>
                                <Typography variant="h6" sx={{ color: 'white', fontWeight: 500 }}>
                                    {previewCard.Header}
                                </Typography>
                            </Box>
                        )}
                    </>
                )}
            </DialogContent>
        </Dialog>
    </div>
        </>
}

export default Diplomat_slide